import {Box, Typography} from "@mui/material";
import * as React from "react";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";
import useIsInRoles from "@/hooks/useIsInRoles";
import {setCardView} from "@/redux/product.params.slice";
import Switch from "@mui/material/Switch";
import {useProductsFilters} from "@/hooks/useProductsFilters";

export default function ProductsViewSettings() {
    const isExists = useAppSelector((state: RootState) => state.products.isExists);
    const isAdminOrPhotographer = useIsInRoles(["Admin", "Photographer"]);
    const dispatch = useAppDispatch()
    const onlyWithPicture = useAppSelector((state: RootState) => state.products.OnlyWithPicture);
    const {updateFilters} = useProductsFilters();

    useEffect(() => {
        if (isExists) {
            dispatch(setCardView(true))
        } else {
            dispatch(setCardView(false))

        }
    }, [isExists]);


    return (
        <>
            {
                isAdminOrPhotographer &&
                <>
                  <Box
                      pr = {{md: 3, xs: 2}}
                      pl = {{md: 3, xs: 0}}
                      mt = {3} mb = {2}
                      display = "flex"
                      alignItems = "center"
                      justifyContent = "space-between"
                  >

                    <Typography
                        fontSize = {16}
                        fontWeight = {400}
                        component = "label"
                        htmlFor = "OnlyWithPicture"
                    >
                      فقط کالاهای با عکس
                    </Typography >

                    <Switch
                        id = "OnlyWithPicture"
                        name = "OnlyWithPicture"
                        checked={onlyWithPicture === true}
                        onChange={(event) =>
                            updateFilters({
                                OnlyWithPicture: event.target.checked,
                            })
                        }
                    />
                  </Box >
                </>
            }
        </>
    );
}
